/*** Product page sections ***/
import {
  initSlider, vndHlp, initProductImageSlider, initThumbs, initTabs, initSwatch, quickViewInit,
  initProductImageGrid, zoomImage, initProductZoomPopup, initSizeChart
} from "//www.framesplus.co.uk/cdn/shop/t/63/assets/theme.js?v=12521087032420980881788879945";
// Product template section
var vndPrdTplSt = {
  _onReviewClick(e) {
    e.preventDefault();
    if ( vndTheme.rvw_app == 'none' ) {
      return;
    }

    vndPrdTplSt._scrToTabs();

    const $tab = document.querySelector('.tabs-nav__item.reviews');
    if ($tab && !$tab.classList.contains('active') ) {
      document.querySelector('.tabs-nav__item.reviews a').click();
    } else {
      const $tab = document.querySelector('.tabs-nav__item.\\@app');
      if ($tab && !$tab.classList.contains('active') ) {
        document.querySelector('.tabs-nav__item.\\@app a').click();
      }
    }
  },

  _onDescClick(e) {
    e.preventDefault();
    vndPrdTplSt._scrToTabs();
    if ( !$('.tabs-nav__item.description').hasClass('active') ) {
      document.querySelector('.tabs-nav__item.description a').click();
    }
  },

  _scrToTabs() {
    $('html, body').animate({
      scrollTop: $('.product-details-tabs').offset().top - 100
    }, 450);
  },

  onLoad(container) {
    initProductImageSlider(container);
    initThumbs(".product-layout");
    initProductImageGrid(container);
    zoomImage(container);
    initProductZoomPopup(container);
    const popups = new vndTheme.Popups(container);

    const $defaultReview = document.querySelector('.product-main .product-review');
    $defaultReview && $defaultReview.addEventListener('click', vndPrdTplSt._onReviewClick);
    const $appReview = document.querySelector('.product-main .shopify-app-block')
    $appReview && $appReview.addEventListener('click', vndPrdTplSt._onReviewClick);

    const $nav_desc = container.querySelector(".nav-to-tab-desc");
    if ($nav_desc) {
      $nav_desc.onclick = vndPrdTplSt._onDescClick;
    }
  }
}

// Product details tabs section
var vndPrdDtTabsSt = {
  onLoad(container) {
    initTabs(container);
  }
}

var vndPrdRecmd = {
  onLoad($container) {
    // Look for an element with class 'product-recommendations'
    var $ctn = $container.querySelector(".product-recommendations");
    if ($ctn === null) {
      return;
    }

    // Read product id from data attribute
    var productId = $ctn.dataset.productId;
    // Read limit from data attribute
    var limit = $ctn.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && 300 > request.status) {
        const container = document.createElement("div");
        container.innerHTML = request.response;
        const prc = container.querySelector(".product-recommendations");

        if (!prc) {
          return false;
        }

        $ctn.parentElement.innerHTML = prc.innerHTML;

        const $slider = $container.querySelector('.items-carousel');
        initSlider($slider);

        quickViewInit();
        initSwatch($container);
      }
    }

    request.send();
  }
}

function adjustStickyLayout() {
  const $mainContent = document.getElementById('MainContent');
  const $stickyLayout = document.querySelector('.template-product--sidebar');

  $stickyLayout.querySelectorAll('.shopify-section').forEach($section => {
    if (!$section.classList.contains('shopify-section-main')) {
      $mainContent.appendChild($section);
    }
  });

  if (vndHlp.isMobile()) {
    const $summary = $stickyLayout.querySelector('.product-details-summary');
    const $form = $stickyLayout.querySelector('.template-product__sticky-form');
    $summary.appendChild($form);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.template-product__sticky-form')) {
    adjustStickyLayout();
  }

  vndHlp.initSct(null, '.vs-product-recommendations', vndPrdRecmd.onLoad);
  vndHlp.initSct(null, '.products-template', vndPrdTplSt.onLoad);
  vndHlp.initSct(null, '.product-details-tabs', vndPrdDtTabsSt.onLoad);

  initSizeChart();
});
